import * as React from 'react';
import { Modal, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import * as actionCreator from '../../actions/actions';
import { Dispatch } from 'redux';
import { Log } from "../../class/Log";
import Select from 'react-select';
import { MyLookup } from '../../class/Enums';
import moment from 'moment';
import { getUserAircraftLookupList, getUserAirportLookupList, getUserFavoritAircraftLookup, getUserFavoritAirportLookup } from './LogBookHelper';
import { UserAircraft } from '../../class/UserAircraft';
import { UserAirport } from '../../class/UserAirport';
import { LookupItem } from '../../class/LookupItem';
import { withFirebaseAuth } from '../../auth/withFirebaseAuth';
import '../css/ModernPopups.css';

interface State {
    logBookId: any;
    logBookDate: any;
    logBookAircraftModel: any;
    logBookAircraftRegistration: any;
    logBookDeparturePlace: any;
    logBookDepartureTime: any;
    logBookArrivalPlace: any;
    logBookArrivalTime: any;
    logBookTotalFlightTime: any;
    logBookDescription: any;
    logBookIFR: any;
    logBookPIC: any;
    logBookNight: any;
    logBookDual: any;
    logBookCoPilot: any;
    logBookLanding: number;
    userAircrafLookuptList: Array<LookupItem>;
    userAirportLookuptList: Array<LookupItem>;
    userSelectedAicraft: LookupItem;
}

interface Props {
    popupTitle: string;
    log: Log;
    show: boolean;
    token: any;
    aircraftModelList: any;
    airportList: any;
    userAircraftList: Array<UserAircraft>;
    userAirportList: Array<UserAirport>;
    firebaseAuth: any;
    
    hide(): void;
    saveLog(token: any, p: Log): void;
    updateLog(token: any, p: Log): void;
    getLookupList(): any;
    getUserAircraftList(token: any): void;
    getUserAirportList(token: any): void;
}

class LogBookPopup extends React.Component<Props, State>{
    private socket: any;

    constructor(props: any) {
        super(props)
        this.state = {
            logBookId: 0,
            logBookDate: "",
            logBookAircraftModel: "",
            logBookAircraftRegistration: "",
            logBookDeparturePlace: "",
            logBookDepartureTime: "",
            logBookArrivalPlace: "",
            logBookArrivalTime: "",
            logBookTotalFlightTime: "",
            logBookDescription: "",
            logBookIFR: null,
            logBookPIC: null,
            logBookNight: null,
            logBookDual: null,
            logBookCoPilot: null,
            logBookLanding: 0,
            userAircrafLookuptList: [],
            userAirportLookuptList: [],
            userSelectedAicraft: { label: "asdasd", value: 1 }
        };
    }

    async componentDidMount() {
        try {
            const token = await this.props.firebaseAuth.getAccessToken();
            if (token) {
                this.props.getLookupList();
                this.props.getUserAircraftList(token);
                this.props.getUserAirportList(token);

                this.setState({
                    userAircrafLookuptList: getUserAircraftLookupList(this.props.userAircraftList),
                    userAirportLookuptList: getUserAirportLookupList(this.props.userAirportList),
                })
            }
        } catch (err) {
            console.error("Error getting token:", err);
        }
    }

    componentDidUpdate(prevProps: any) {
        let aircraftLabel = this.props.log.userAircraft != undefined ? `${this.props.log.userAircraft.aircraftModel?.aircraftModelName || ''} | ${this.props.log.userAircraft.aircraftRegistration || ''}`
            : getUserFavoritAircraftLookup(this.props.userAircraftList).label;
        let aircraftValue = this.props.log.userAircraft != undefined ? this.props.log.userAircraft.userAircraftId
            : getUserFavoritAircraftLookup(this.props.userAircraftList).value;
        let airportDepartureLabel = this.props.log.airportDeparture != undefined ? this.props.log.airportDeparture.airportName + " | " + this.props.log.airportDeparture.airportCode
            : getUserFavoritAirportLookup(this.props.userAirportList).label;
        let airportArrivalLabel = this.props.log.airportArrival != undefined ? this.props.log.airportArrival.airportName + " | " + this.props.log.airportArrival.airportCode
            : getUserFavoritAirportLookup(this.props.userAirportList).label;
        let airportDepartureValue = this.props.log.airportDeparture != undefined ? this.props.log.airportDeparture.airportId
            : getUserFavoritAirportLookup(this.props.userAirportList).value;
        let airportArrivalValue = this.props.log.airportArrival != undefined ? this.props.log.airportArrival.airportId
            : getUserFavoritAirportLookup(this.props.userAirportList).value;

        //Edit Mode
        if (this.props !== prevProps) {
            this.setState({
                logBookId: this.props.log.logBookId,
                logBookDate: moment.parseZone(this.props.log.logBookDate).format('DD/MM/YYYY'),
                logBookAircraftModel: { label: aircraftLabel, value: aircraftValue },
                logBookDeparturePlace: { label: airportDepartureLabel, value: airportDepartureValue },
                logBookDepartureTime: this.props.log.logBookDepartureTime,
                logBookArrivalPlace: { label: airportArrivalLabel, value: airportArrivalValue },
                logBookArrivalTime: this.props.log.logBookArrivalTime,
                logBookTotalFlightTime: this.props.log.logBookTotalFlightTime,
                logBookDescription: this.props.log.logBookDescription,
                logBookIFR: this.props.log.logBookIFR != null ? this.props.log.logBookIFR : false,
                logBookPIC: this.props.log.logBookPIC != null ? this.props.log.logBookPIC : false,
                logBookCoPilot: this.props.log.logBookCoPilot != null ? this.props.log.logBookCoPilot : false,
                logBookDual: this.props.log.logBookDual != null ? this.props.log.logBookDual : false,
                logBookNight: this.props.log.logBookNight != null ? this.props.log.logBookNight : false,
                logBookLanding: this.props.log.logBookLanding != undefined ? this.props.log.logBookLanding : 0,
                userAircrafLookuptList: getUserAircraftLookupList(this.props.userAircraftList),
                userAirportLookuptList: getUserAirportLookupList(this.props.userAirportList),
            })
        }
    }

    handleChange = (e: any) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        this.setState({
            [e.target.id]: value
        } as any);
    }

    handleAircraftChange = (logBookAircraftModel: any) => {
        this.setState({ logBookAircraftModel : logBookAircraftModel });
    };

    handleAirportDepartureChange = (logBookDeparturePlace: any) => {
        this.setState({ logBookDeparturePlace });
    };

    handleAirportArrivalChange = (logBookArrivalPlace: any) => {
        this.setState({ logBookArrivalPlace });
    };

    handleDepartureChange = (e: any) => {
        this.setState({
            logBookDepartureTime: e.target.value,
        });
        if (this.state.logBookArrivalTime != undefined) {
            this.calculateFlightTime(e.target.value, this.state.logBookArrivalTime);
        }
    }

    handleArrivalChange = (e: any) => {
        this.setState({
            logBookArrivalTime: e.target.value,
        });
        if (this.state.logBookDepartureTime != undefined) {
            this.calculateFlightTime(this.state.logBookDepartureTime, e.target.value);
        }
    }

    /**
     * Calculates the flight time between two given times and updates the state with the result.
     *
     * @param {string} depart - Departure time in the format 'HH:MM'.
     * @param {string} arrival - Arrival time in the format 'HH:MM'.
     */
    calculateFlightTime = (depart: string, arrival: string) => {
        // Initialize total time and split departure and arrival times into hours and minutes
        let totalTime = 0;
        let startTime = depart.split(':') as any;
        let endTime = arrival.split(':') as any;
    
        // Calculate the total time in hour
        totalTime =  parseFloat((((endTime[0] * 60 + Number(endTime[1])) - (startTime[0] * 60 + Number(startTime[1])))/60).toFixed(2));
    
        // Update the component's state with the flight time in hours
        this.setState({
            logBookTotalFlightTime: totalTime,
        });
    }

    handleSaveLog = (e: any) => {
        e.preventDefault();
        var myLog: Log = ({
            logBookId: this.state.logBookId,
            logBookDate: moment.utc(this.state.logBookDate, 'DD/MM/YYYY').toDate(),
            airportDepartureId: this.state.logBookDeparturePlace.value,
            airportArrivalId: this.state.logBookArrivalPlace.value,
            logBookDepartureTime: this.state.logBookDepartureTime,
            logBookArrivalTime: this.state.logBookArrivalTime,
            logBookTotalFlightTime: this.state.logBookTotalFlightTime,
            logBookDescription: this.state.logBookDescription,
            logBookCoPilot: this.state.logBookCoPilot,
            logBookNight: this.state.logBookNight,
            logBookDual: this.state.logBookDual,
            logBookIFR: this.state.logBookIFR,
            logBookPIC: this.state.logBookPIC,
            logBookLanding: this.state.logBookLanding,
            userAircraftId: this.state.logBookAircraftModel.value,
            LogBookAircraftRegistration : this.state.logBookAircraftModel.label,
        });
        if (myLog.logBookId != undefined) {
           this.props.updateLog(this.props.token, myLog);
        }
        else {
           this.props.saveLog(this.props.token, myLog);
        }

        this.props.hide();
    }

    render() {
        return (
            <Modal 
                show={this.props.show} 
                onHide={() => this.props.hide()}
                className="modern-modal"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-plane"></i>
                        {this.props.popupTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form id="newUserForm" onSubmit={this.handleSaveLog}>
                        <input 
                            id="logBookId" 
                            value={this.state.logBookId || ''} 
                            type="hidden" 
                            readOnly 
                        />

                        {/* Flight Characteristics */}
                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-clipboard-check"></i>
                                Flight Characteristics
                            </label>
                            <div className="modern-checkbox-group">
                                <div className={`modern-checkbox ${this.state.logBookIFR ? 'checked' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        checked={this.state.logBookIFR} 
                                        id="logBookIFR" 
                                        onChange={this.handleChange}
                                    />
                                    <label htmlFor="logBookIFR">IFR</label>
                                </div>
                                <div className={`modern-checkbox ${this.state.logBookNight ? 'checked' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        checked={this.state.logBookNight} 
                                        id="logBookNight" 
                                        onChange={this.handleChange}
                                    />
                                    <label htmlFor="logBookNight">Night</label>
                                </div>
                                <div className={`modern-checkbox ${this.state.logBookPIC ? 'checked' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        checked={this.state.logBookPIC} 
                                        id="logBookPIC" 
                                        onChange={this.handleChange}
                                    />
                                    <label htmlFor="logBookPIC">PIC</label>
                                </div>
                                <div className={`modern-checkbox ${this.state.logBookCoPilot ? 'checked' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        checked={this.state.logBookCoPilot} 
                                        id="logBookCoPilot" 
                                        onChange={this.handleChange}
                                    />
                                    <label htmlFor="logBookCoPilot">Co-Pilot</label>
                                </div>
                                <div className={`modern-checkbox ${this.state.logBookDual ? 'checked' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        checked={this.state.logBookDual} 
                                        id="logBookDual" 
                                        onChange={this.handleChange}
                                    />
                                    <label htmlFor="logBookDual">Dual</label>
                                </div>
                            </div>
                        </div>

                        {/* Flight Date */}
                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-calendar-day"></i>
                                Flight Date
                            </label>
                            <input
                                id="logBookDate"
                                value={this.state.logBookDate}
                                type="text"
                                placeholder="dd/MM/yyyy"
                                pattern="\d{2}/\d{2}/\d{4}"
                                className="modern-form-control"
                                required
                                onChange={this.handleChange}
                            />
                        </div>

                        {/* Aircraft */}
                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-plane"></i>
                                Aircraft Model / Registration
                            </label>
                            <div className="modern-select">
                                <Select 
                                    id="logBookAircraftModel" 
                                    onChange={this.handleAircraftChange} 
                                    options={this.state.userAircrafLookuptList} 
                                    placeholder="Select aircraft model and registration" 
                                    value={this.state.logBookAircraftModel}
                                />
                            </div>
                        </div>

                        {/* Route Information */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-map-marker-alt"></i>
                                        Departure Airport
                                    </label>
                                    <div className="modern-select">
                                        <Select 
                                            id="logBookDeparturePlace" 
                                            onChange={this.handleAirportDepartureChange} 
                                            options={this.props.airportList} 
                                            placeholder="Select departure airport" 
                                            value={this.state.logBookDeparturePlace}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-map-marker-alt"></i>
                                        Arrival Airport
                                    </label>
                                    <div className="modern-select">
                                        <Select 
                                            id="logBookArrivalPlace" 
                                            onChange={this.handleAirportArrivalChange} 
                                            options={this.props.airportList} 
                                            placeholder="Select arrival airport" 
                                            value={this.state.logBookArrivalPlace}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Time Information */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-clock"></i>
                                        Departure Time
                                    </label>
                                    <input
                                        id="logBookDepartureTime"
                                        value={this.state.logBookDepartureTime || ''}
                                        type="text"
                                        placeholder="HH:MM"
                                        pattern="\d{2}:\d{2}"
                                        className="modern-form-control"
                                        required
                                        onChange={this.handleDepartureChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-clock"></i>
                                        Arrival Time
                                    </label>
                                    <input
                                        id="logBookArrivalTime"
                                        value={this.state.logBookArrivalTime || ''}
                                        type="text"
                                        placeholder="HH:MM"
                                        pattern="\d{2}:\d{2}"
                                        className="modern-form-control"
                                        required
                                        onChange={this.handleArrivalChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Flight Details */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-stopwatch"></i>
                                        Total Flight Time (hours)
                                    </label>
                                    <input 
                                        id="logBookTotalFlightTime" 
                                        value={this.state.logBookTotalFlightTime || ''} 
                                        type="number" 
                                        step="0.1"
                                        className="modern-form-control" 
                                        placeholder="Auto-calculated or manual entry" 
                                        required 
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-sort-amount-down"></i>
                                        Number of Landings
                                    </label>
                                    <input 
                                        id="logBookLanding" 
                                        value={this.state.logBookLanding || ''} 
                                        type="number" 
                                        min="0"
                                        className="modern-form-control" 
                                        placeholder="Enter number of landings" 
                                        required 
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Notes */}
                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-sticky-note"></i>
                                Flight Notes
                            </label>
                            <textarea 
                                id="logBookDescription" 
                                value={this.state.logBookDescription} 
                                rows={4} 
                                className="modern-form-control" 
                                placeholder="Add any additional notes about this flight (weather conditions, training exercises, etc.)" 
                                onChange={this.handleChange}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hide()}>
                        <i className="fas fa-times me-2"></i>
                        Cancel
                    </Button>
                    <Button variant="success" type="submit" form="newUserForm">
                        <i className="fas fa-save me-2"></i>
                        Save Flight Log
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        userId: state.userId,
        isDoorCodeValid: state.isNewDoorCodeValid,
        aircraftModelList: state.lookupList[MyLookup.AircraftList],
        airportList: state.lookupList[MyLookup.AirportList],
        userAircraftList: state.userAircraftList,
        userAirportList: state.userAirportList,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        saveLog: (token: any, log: any) => dispatch<any>(actionCreator.default.logbook.addLog(token, log)),
        updateLog: (token: any, log: any) => dispatch<any>(actionCreator.default.logbook.updateLog(token, log)),
        getLookupList: () => dispatch<any>(actionCreator.default.lookup.getLookupList()),
        getUserAircraftList: (token: any) => dispatch<any>(actionCreator.default.userAircraft.getUserAircraftList(token)),
        getUserAirportList: (token: any) => dispatch<any>(actionCreator.default.userAirport.getUserAirportList(token)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFirebaseAuth(LogBookPopup));
